/*
 * allgemeine Hilfsfunktionen
 */

export function formatPrice(val) {
    // Wenn der Preis "0" ist, wird 0,00 ausgegeben. Wenn er "null" ist, ein leerer String.
    if ( (typeof val !== 'undefined') && (val !== null) ) {
        return '€\xa0' + val.toFixed(2).toLocaleString('de-DE').replace('.', ',')
    } else {
        return ''
    }
}

export function trimName(name, artNum = null) {
    // Dateinamenteil aus Artikelname extrahieren für artNum2name
    // "fußset design alu" wird zu "alu"
    // "fußset block | schwarz" wird zu "block"
    // "fußset avantgarde schwarz" wird zu "avantgarde_90" (ID aus Artikelnummer bei Farbvarianten)
    let arrName = name.split('|')[0].trim().toLowerCase().split(' ')
    // we only want the last name part, e.g. only
    // "canberra" for the value "head board canberra"
    while (arrName.length > 1) {
        arrName.shift()
    }
    if (artNum) {
        // Anhängsel zur Unterscheidung der Farbvarianten bei den Füßen:
        let artNumPart = artNum.split('-')[1]
        if (artNumPart) {
            arrName.push(artNumPart)
        }
    }
    return arrName.join('_')
}

export function logDebug(msg, noI = false) {
    if (window.debug) {
        if (noI) {
            console.log(msg)
        } else {
            console.log('(i) ' + msg)
        }
    }
}

export function handleResize(e) {
    // Höhe der Sidebar bei Resize & Load anpassen (macht eigentlich schon das CSS, aber das funktioniert in den mobilen Browsern nicht richtig)
    setTimeout(function () {
        if (window.innerWidth < 700) {
            document.getElementById('sidebar').style.height = window.innerHeight - 270 + 'px'
        } else {
            document.getElementById('sidebar').style.height = window.innerHeight + 'px'
        }
    })
}